import React, { createContext, useState, useContext, useEffect } from 'react';
import { pb, getCurrentUser, isAuthenticated, isAdmin, isStudent, isTeacher, isCompany, isCommercial, isPedagogical, isSuperAdmin, logout } from '../services/pocketbase';

// Cru00e9ation du contexte
const AuthContext = createContext(null);

// Hook personnalisu00e9 pour utiliser le contexte d'authentification
export const useAuth = () => useContext(AuthContext);

// Fournisseur du contexte d'authentification
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Initialiser l'état au chargement
    const initAuth = () => {
      if (isAuthenticated()) {
        setCurrentUser(getCurrentUser());
      } else {
        setCurrentUser(null);
      }
      setLoading(false);
    };
    
    // Écouter les changements d'authentification
    pb.authStore.onChange(() => {
      if (isAuthenticated()) {
        setCurrentUser(getCurrentUser());
      } else {
        setCurrentUser(null);
      }
    });
    
    // Initialiser immédiatement
    initAuth();
  }, []);
  
  const login = async (email, password) => {
    try {
      const authData = await pb.collection('users').authWithPassword(email, password);
      
      // Vérifier si le compte est actif
      if (authData.record.status === false) {
        // Déconnecter immédiatement l'utilisateur inactif
        logout();
        return { 
          success: false, 
          inactive: true, 
          message: 'Compte désactivé' 
        };
      }
      
      setCurrentUser(authData.record);
      return { success: true, user: authData.record };
    } catch (error) {
      console.error('Erreur de connexion:', error);
      return { success: false, message: error.message || 'Erreur de connexion' };
    }
  };
  
  const handleLogout = () => {
    logout();
    setCurrentUser(null);
  };
  
  // Vu00e9rifier les ru00f4les
  const checkIsAdmin = () => {
    return isAdmin();
  };

  const checkIsCommercial = () => {
    return isCommercial();
  };

  const checkIsPedagogical = () => {
    return isPedagogical();
  };
  
  const checkIsStudent = () => {
    return isStudent();
  };

  const checkIsCompany = () => {
    return isCompany();
  };

  const checkIsTeacher = () => {
    return isTeacher();
  };

  const checkIsSuperAdmin = () => {
    return isSuperAdmin();
  };

  // Fonction pour récupérer le partner_id de l'utilisateur connecté
  const getPartnerId = () => {
    const user = getCurrentUser();
    return user?.partner_id || null;
  };
  
  // Valeur du contexte
  const value = {
    currentUser,
    isAuthenticated: isAuthenticated(),
    isAdmin: checkIsAdmin(),
    isStudent: checkIsStudent(),
    isCompany: checkIsCompany(),
    isCommercial: checkIsCommercial(),
    isPedagogical: checkIsPedagogical(),
    isTeacher: checkIsTeacher(),
    isSuperAdmin: checkIsSuperAdmin(),
    getPartnerId,
    login,
    logout: handleLogout,
    loading
  };
  
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
